import React from "react";
import { Card, Icon, Tooltip } from "@scuf/common";
import './AnomalyBelt.scss';

const AnomalyBelt = (props: any) => {
    return (
        <Card className="anomaly-card">
            <Card.Content>
                <div className="card-row">
                    {
                        props.opportunityDetail.header_details &&
                        Object.entries(props.opportunityDetail.header_details[0].labels).map(([key, value]:any, index) => {
                            return (
                                <div className={`one_elem_${index + 1}`}>
                                    { <>
                                        <div>
                                        {value.description? <Tooltip
                                                    content={value.description}
                                                    element={
                                                        <p>{value.label}</p>
                                                    }
                                                    position="top left"
                                                    event="hover"
                                                    hoverable={true}
                                                /> :  <>{value.label}</>
                                                }
                                            </div>
                                    
                                         {value.label === "Alert" ? <>
                                            <div className="card-column-value">{props.opportunityDetail.header_details[0].values[0][`${"value" + (index + 1)}`]}
                                                <Tooltip
                                                    className='disclaimer_box__tooltip'
                                                    content="Please click here to see the alert description in detail"
                                                    element={
                                                        <a  className="belt-icon" href="https://honeywellprod.sharepoint.com/sites/DWP-Functions/finance/Corporate%20Audit/CAMS/Pages/CAMS-User-Guides.aspx?csf=1&web=1&e=G2zP2u&cid=9ba60eb1-c2b1-4387-953d-a0d6e75661d2)" target="_blank">
                                                            <Icon className="help-icon" name="badge-help" size="small" />
                                                        </a>
                                                    }
                                                    position="right center"
                                                    event="hover"
                                                    hoverable={true}
                                                />
                                            </div>
                                        </> : 
                                            <div className="card-column-value">{props.opportunityDetail.header_details[0].values[0][`${"value" + (index + 1)}`]}</div>
                                       }
                                        </>
                                    }
                                    
                                </div>
                            )
                        }
                        )
                    }
                </div>
            </Card.Content>
        </Card>
    )
}

export default AnomalyBelt;